import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useExportLogCSV, useExtractionLogsPaginated } from '@/hooks/useKnowledge';
import { LogsTable } from '@/components/knowledge/LogsTable';
import { MetricsDashboard } from '@/components/knowledge/MetricsDashboard';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';

export function KnowledgeExtractionLogsPage() {
  const navigate = useNavigate();
  const location = useLocation();

  const handleBack = () => {
    if (location.key !== 'default') {
      navigate(-1);
    } else {
      navigate('/settings/knowledge-extraction');
    }
  };
  const [page, setPage] = useState(1);
  const limit = 20;
  const exportLogCsv = useExportLogCSV();
  const { data, isLoading } = useExtractionLogsPaginated({ page, limit });

  const logs = data?.data || [];
  const pagination = data?.pagination;

  return (
    <div className="container mx-auto py-4 md:py-6 lg:py-8 px-4 md:px-6 space-y-6 md:space-y-8">
      <div className="flex items-center gap-4">
        <Button variant="ghost" onClick={handleBack}>
          <ArrowLeft className="h-4 w-4 mr-2" />
          Voltar
        </Button>
        <h1 className="text-3xl font-bold">Logs de Extração</h1>
      </div>

      {isLoading ? (
        <div className="text-center py-12 text-muted-foreground">
          Carregando logs...
        </div>
      ) : logs.length > 0 && pagination ? (
        <>
          <MetricsDashboard logs={logs} />
          <LogsTable
            logs={logs}
            page={pagination.page}
            totalPages={pagination.totalPages}
            total={pagination.total}
            exportingLogId={exportLogCsv.isPending ? exportLogCsv.variables : null}
            onPageChange={setPage}
            onRowClick={(id) => navigate(`/settings/knowledge-extraction/logs/${id}`)}
            onExportCsv={(id) => exportLogCsv.mutate(id)}
          />
        </>
      ) : (
        <div className="text-center py-12 text-muted-foreground">
          Nenhum log encontrado
        </div>
      )}
    </div>
  );
}
